var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4345)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 33C42.5166 33 41.0666 33.4399 39.8332 34.264C38.5999 35.0881 37.6386 36.2594 37.0709 37.6299C36.5032 39.0003 36.3547 40.5083 36.6441 41.9632C36.9335 43.418 37.6478 44.7544 38.6967 45.8033C39.7456 46.8522 41.082 47.5665 42.5368 47.8559C43.9917 48.1453 45.4997 47.9968 46.8701 47.4291C48.2406 46.8614 49.4119 45.9001 50.236 44.6668C51.0601 43.4334 51.5 41.9834 51.5 40.5C51.5 38.5109 50.7098 36.6032 49.3033 35.1967C47.8968 33.7902 45.9891 33 44 33ZM44 45C43.11 45 42.24 44.7361 41.4999 44.2416C40.7599 43.7471 40.1831 43.0443 39.8425 42.2221C39.5019 41.3998 39.4128 40.495 39.5865 39.6221C39.7601 38.7492 40.1887 37.9474 40.818 37.318C41.4474 36.6887 42.2492 36.2601 43.1221 36.0865C43.995 35.9128 44.8998 36.0019 45.7221 36.3425C46.5443 36.6831 47.2471 37.2599 47.7416 37.9999C48.2361 38.74 48.5 39.61 48.5 40.5C48.5 41.6935 48.0259 42.8381 47.182 43.682C46.3381 44.5259 45.1935 45 44 45ZM44 24C39.6255 24.005 35.4315 25.7449 32.3382 28.8382C29.2449 31.9315 27.505 36.1255 27.5 40.5C27.5 46.3875 30.2206 52.6275 35.375 58.5469C37.691 61.2217 40.2977 63.6303 43.1469 65.7281C43.3991 65.9048 43.6996 65.9996 44.0075 65.9996C44.3154 65.9996 44.6159 65.9048 44.8681 65.7281C47.712 63.6294 50.3137 61.2208 52.625 58.5469C57.7719 52.6275 60.5 46.3875 60.5 40.5C60.495 36.1255 58.7551 31.9315 55.6618 28.8382C52.5685 25.7449 48.3745 24.005 44 24ZM44 62.625C40.9006 60.1875 30.5 51.2344 30.5 40.5C30.5 36.9196 31.9223 33.4858 34.4541 30.9541C36.9858 28.4223 40.4196 27 44 27C47.5804 27 51.0142 28.4223 53.5459 30.9541C56.0777 33.4858 57.5 36.9196 57.5 40.5C57.5 51.2306 47.0994 60.1875 44 62.625Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4345",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/c-2.b0180b749f253db2a5836689fc8ac924.svg";
export { ForwardRef as ReactComponent };